<template>
  <div class="min-h-screen">
    <!-- SEO Meta Tags -->
    <PageSEO
      title="Our Projects - Web Development Portfolio"
      description="Explore our portfolio of successful web development projects, modern applications, and digital solutions. See how we've helped businesses achieve their goals."
      :keywords="['portfolio', 'projects', 'web development', 'case studies', 'work examples', 'client projects']"
      url="https://vedware.com/projects"
    />

    <!-- Hero Section -->
    <HeroSection
      :icon="PhFolderOpen"
      title="Our"
      highlighted-title="Projects"
      description="Explore our portfolio of successful web development projects, modern applications, and digital solutions. See how we've helped businesses achieve their goals."
    />

    <!-- Projects Grid Section -->
    <div class="py-20">
      <div class="container mx-auto px-6">
        <div class="mx-auto max-w-7xl">
          <ProjectsGrid :projects="projects" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { PhFolderOpen } from '@phosphor-icons/vue'
import ProjectsGrid from '~/components/Projects/ProjectsGrid.vue'
import HeroSection from '~/components/Shared/HeroSection.vue'
import PageSEO from '~/components/Shared/PageSEO.vue'
import { projects } from '~/utils/projects'
</script>
